export const shouldShowVendorRank = (rfqData) => {
  if (!rfqData?.displayRanks) return false;

  const currentSupplier = rfqData?.suppliers?.[0];
  if (typeof currentSupplier?.canViewRank === "boolean") {
    return currentSupplier.canViewRank;
  }

  const legacyVisibleSupplierIds = Array.isArray(rfqData?.displayRankSupplierIds)
    ? rfqData.displayRankSupplierIds.map((supplierId) => String(supplierId)).filter(Boolean)
    : [];

  if (legacyVisibleSupplierIds.length === 0) return true;

  const currentSupplierId = currentSupplier?.supplierId;
  return Boolean(currentSupplierId && legacyVisibleSupplierIds.includes(String(currentSupplierId)));
};